import { AxiosRequestConfig, AxiosResponse } from 'axios';
import axiosInstance from './axiosConfiguration';

export const DECKARD_API_URL = process.env.REACT_APP_DECKARD_API_URL;
export const DIGIFIER_API_URL = process.env.REACT_APP_DIGIFIER_API_URL;

export const httpMethodFunctions = {
  get: async <T, D = any>(
    url: string,
    config: AxiosRequestConfig<D> = {}
  ): Promise<AxiosResponse<T, D>> => {
    return axiosInstance.get(url, config);
  },
  post: async <T = any, D = any>(
    url: string,
    data: T,
    config: AxiosRequestConfig<T> = {}
  ): Promise<AxiosResponse<D>> => axiosInstance.post(url, data, config),
  put: axiosInstance.put,
  delete: axiosInstance.delete,
};
